// JavaScript (campaigns_sign_controller.js)
import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['signsContainer'];
  static values = { id: Number, target: String, offlineno: Number, withNoBody: Boolean };

  connect() {
    this.loadSigns();
  }

  loadSigns() {
    this.fetchWithPage(1, 10);
  }

  fetchWithPage(pageNumber, pageSize) {
    if (!this.hasIdValue) return;
    const url = `/campaignsSigns/${this.idValue}?offlineno=${this.offlinenoValue}&pageSize=${pageSize}&pageNumber=${pageNumber}&withNoBody=${this.withNoBodyValue}`;
    fetch(url)
      .then((response) => response.text())
      .then((data) => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(data, 'text/html');
        const campaignsSignsContent = htmlDoc.getElementById('campaigns-signs-content');
        if (campaignsSignsContent) {
          this.signsContainerTarget.innerHTML = '';
          this.signsContainerTarget.appendChild(campaignsSignsContent);
        } else {
          console.error('Invalid response format: campaignsSignsContent not found');
        }
      })
      .catch((error) => console.error('Error:', error));
  }

  goToPage(event) {
    const pageNumber = event.params['pageNumber'];
    const pageSize = event.params['pageSize'];
    this.fetchWithPage(pageNumber, pageSize);
  }
}
